// @flow

import * as React from 'react';
import { createFragmentContainer, graphql } from 'react-relay/compat';
import { AttributeTable, AttributeTableRow } from 'app/components/shared/AttributeTable';
import JobEvent from '../JobEvent';
import type { JobEventCreated_event } from './__generated__/JobEventCreated_job.graphql';

type Props = {
  job: JobEventCreated_event,
  previousTimestamp: ?string
};

function TableValue({ children }: { children: React.Node }) {
  return <code className="block dark-gray monospace">{ children }</code>;
}

function TableEmptyValue() {
  return <TableValue>-</TableValue>;
}

function JobEventCreated({ job, previousTimestamp }: Props) {
  return (
    <JobEvent timestamp={job.createdAt} previousTimestamp={previousTimestamp}>
      <JobEvent.Label>
        Job Created
      </JobEvent.Label>
      <JobEvent.Content>
        <AttributeTable>
          <AttributeTableRow title="Agent Targeting Rules">
            {job.agentQueryRules.length === 0 ? <TableEmptyValue /> : (
              <React.Fragment>
                {job.agentQueryRules.map((query) => (
                  <TableValue key={query}>{query}</TableValue>
                ))}
              </React.Fragment>
            )}
          </AttributeTableRow>
          {job.step?.key ? (
            <AttributeTableRow title="Step Key">
              <TableValue title={job.step.uuid}>{job.step.key}</TableValue>
            </AttributeTableRow>
          ) : null }
          {job.step?.dependencies.edges.length ? (
            <AttributeTableRow title="Step Dependencies">
              {job.step.dependencies.edges.map(({ node }) => (
                <div key={node.uuid}>
                  <TableValue>{node.key}</TableValue>
                </div>
              ))}
            </AttributeTableRow>
          ) : null }
          {job.step?.conditional ? (
            <AttributeTableRow title="Step Conditional">
              <TableValue>{job.step.conditional}</TableValue>
            </AttributeTableRow>
          ) : null }
        </AttributeTable>
      </JobEvent.Content>
    </JobEvent>
  );
}

export default createFragmentContainer(JobEventCreated, {
  job: graphql`
    fragment JobEventCreated_job on JobTypeCommand {
      ... on JobTypeCommand {
        uuid
        createdAt
        agentQueryRules
        step {
          uuid
          key
          conditional
          dependencies(first: 10) {
            edges {
              node {
                uuid
                key
              }
            }
          }
        }
      }
    }
  `
});
